"use client";

import { useEffect, type React } from "react";
import Navbar from "@/components/layout/navbar";
import Footer from "@/components/layout/footer";
import BackButton from "@/components/ui/back-button";
import { useLocation } from "react-router-dom";

// Pages where the back button should NOT appear
const NO_BACK_PATHS = ["/", "/blog", "/test-series", "/materials", "/current-affairs", "/articles", "/pyqs", "/results", "/about", "/contact", "/careers"];

export default function Chrome({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith("/admin") || pathname.startsWith("/dashboard");
  const isHome = pathname === "/";
  /* Scroll to top of page on route change */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {!isDashboard && <Navbar />}

      <main
        // Prevent fixed navbar from covering page content.
        className={!isDashboard ? "flex-1 pt-28 sm:pt-32" : "flex-1"}
      >
        {children}
      </main>

      {!isDashboard && <Footer />}
    </div>
  );
}
